<template>
  <div class="auth-container">
    <h1>Sign in</h1>

    <form @submit.prevent="submit">
      <div class="form-group">
        <label>Email</label>
        <div class="input-wrapper">
          <input type="text" v-model.trim="formModel.email" placeholder="Email" autofocus />
        </div>
      </div>

      <div class="form-group">
        <label>Password</label>
        <div class="input-wrapper">
          <input type="password" v-model.trim="formModel.password" placeholder="Password" />
        </div>
      </div>

      <div v-for="error in errors" :key="error" class="auth-error">
        {{ error }}
      </div>

      <div class="submit-group">
        <button :disabled="isSubmitDisabled" class="btn btn-blue">Sign in</button>

        <p class="forgot">
          <router-link class="blue-link" to="/reset">Forgot password?</router-link>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { proccessError } from '@/helpers/utils';

export default {
  name: 'Login',
  data: () => ({
    formModel: {
      email: '',
      password: '',
    },
    errors: [],
    isSubmitDisabled: false,
  }),
  watch: {
    formModel: {
      handler() {
        this.errors = [];
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      this.isSubmitDisabled = true;

      try {
        await this.$store.dispatch('auth/login', this.formModel);
        this.$router.push('/account');
      } catch (e) {
        this.isSubmitDisabled = false;
        this.errors = proccessError(e.response.data);
      }
    },
  },
  created() {
    this.$store.commit('setSimpleLayout', true);
  },
};
</script>

<style lang="less" scoped>
  .auth-container {
    .submit-group {
      .forgot {
        text-align: center;
        margin-top: 15px;

        a {
          font-size: .875rem;
        }
      }
    }
  }

</style>
